var AccountSettings = (function ($) {
     
     var addDeleteAction = function(deleteAccountButton, varName, selector, errorSelector, uri) {
        deleteAccountButton.on('click', function(e) {
           e.preventDefault();
           openDeleteConfirmationBox();
        });
     };
    var openDeleteConfirmationBox = function () {
            jQuery.fancybox({
                'content': $('#delete-account-popup'),
                'afterShow' : function() {
                            jQuery("#delete-account-no-button").on('click', function() {
                                ret = false;
                                $.fancybox.close();
                            })
                            jQuery("#delete-account-yes-button").on('click', function() {
                                ret = true;
                                deleteAccount();
                                $.fancybox.close();

                            })
                        },
            });
        };

    var deleteAccount= function(){
        var token = $("input[name='_csrf']").val();
        var header = "X-CSRF-TOKEN";
        $.ajax({
             url: "/my-account/delete",
             type: 'POST',
             beforeSend: function(xhr) {
                xhr.setRequestHeader(header, token);
             },
             success: function (response,textStatus, xhr) {
                window.location.href = "/logout";
             },
             error: function (xhr, status, error) {
                $("#account-delete-error").show();
             }
        });
    };

    var validateOnBlur = function($formDataId) {
        var formDataSelector = $formDataId === undefined ? ".j-submit-form" : $formDataId  + " .j-submit-form";
        $(formDataSelector).on({
            "focusout": function handleAddressFormInputBlur(event) {
                var target = event.target;

                if (target.disabled) {
                    return event;
                }

                window.THEME.$document.trigger("validateFormInputOnBlur", [$(event.target)]);
            }
        }, ":input[data-validation-required='1'], :input[data-empty-or-validate='1']");
    };

    var validateOnKeyUp = function($formDataId) {
        var formDataSelector = $formDataId === undefined ? ".j-submit-form" : $formDataId  + " .j-submit-form";
        $(formDataSelector).on({
            'keyup': function handleCheckoutFormKeyupWithRegexp(event) {
                var target = event.target;

                if ((target.getAttribute('data-validation-required') === '1')
                    || (target.getAttribute('data-empty-or-validate') === '1')) {
                    window.THEME.$document.trigger('validateFormInputOnKeyup', [$(this)]);
                }
            }
        }, "input")
    };

    var validateBeforeContinue = function ($formDataId) {
        var formDataSelector = $formDataId === undefined ? ".j-submit-form" : $formDataId  + " .j-submit-form";
        $(formDataSelector).on({
            'validate-before-continue': function handleCheckoutFormInputValidationBeforeContinue(event) {
                var target = event.target;

                if (target.disabled) {
                    return event;
                }

                window.THEME.$document.trigger("validateFormInputBeforeContinue", [$(event.target)]);
            }
        }, ":input[data-validation-required='1'], :input[data-empty-or-validate='1']");
    };

    var initFormValidationEventHandlers = function () {
        window.THEME.$document.on('addFrontEndFormValidation', function(event, $formData) {
            var formDataId = "#" + $formData.attr("id");
            validateOnBlur(formDataId);
            validateOnKeyUp(formDataId);
            validateBeforeContinue(formDataId);
        });
    };

    return {
        initFormValidationEventHandlers : initFormValidationEventHandlers,
        addDeleteAction : addDeleteAction,
        validateOnBlur : validateOnBlur,
        validateOnKeyUp : validateOnKeyUp,
        validateBeforeContinue : validateBeforeContinue
    }
}) (jQuery);

$(document).ready(function () {

    AccountSettings.initFormValidationEventHandlers();
    AccountSettings.validateOnBlur();
    AccountSettings.validateOnKeyUp();
    AccountSettings.validateBeforeContinue();

    var deleteAccountButton = $("#delete-account-button");

    if (typeof deleteAccountButton !== 'undefined' ) {
        AccountSettings.addDeleteAction(deleteAccountButton);
    }
});